<template>
  <div class="history-address">
    <ul>
      <li
        v-for="(item,index) in historyList"
        :key="index"
        @click="goToDetail(item)"
      >{{item.region}}{{item.address}}</li>
    </ul>
  </div>
</template>
<script>
import axios from "../../http";
import { mapState } from "vuex";
export default {
  name: "history_address",
  components: {},
  props: {},
  data() {
    return {
      historyList: []
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {
    this.getHistoryAddress();
  },
  destroyed() {},
  methods: {
    getHistoryAddress() {
      axios
        .fetchPost("/member/work_address/gets", { token: this.token })
        .then(res => {
          let data = res.data;
          // console.log("data :", data);
          if (data.code == 200) {
            this.historyList = [].concat(data.data);
          }
        });
    },
    goToDetail(item) {
      //成功添加地址
      this.$router.push({
        path: "/workAddress",
        query: { data: item }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.history-address
  ul
    padding-top 10px
    text-align left
    li
      margin-bottom 10px
      padding 14px 12px
      background #fff
      font-size 14px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(40, 40, 40, 1)
      line-height 20px
</style>